import freeImage from './image/free.png';
import './image/pro.png';
import './image/pro-discount-25.png';
import './image/team.png';
import './image/business.png';

import './plan.style.sass';
import template from './plan.tpl.pug';

class PlanController {
    select() {
        return this.onClick();
    }

    urlChanged(url) {
        if (!url) {
            this.image = freeImage;
        }
    }
}

export default {
    selector: 'dbPlan',
    template: template(),
    controller: PlanController,
    bindings: {
        image: '<',
        color: '<',
        name: '<',
        description: '<',
        subscription: '<',
        features: '<',
        upgrade: '<',
        onClick: '&'
    }
};



// WEBPACK FOOTER //
// ./src/common/component/plans/component/plan/plan.cmpt.js